import {
  FaBuilding,
  FaCar,
  FaCode,
  FaGamepad,
  FaGlobe,
  FaMap,
  FaPalette,
  FaSlidersH,
  FaUser,
  FaLaptopCode,
  FaClipboardList,
  FaQuestionCircle,
} from "react-icons/fa";

export const CATEGORIES = [
  {
    key: "programmers",
    discordRole: "Programista",
    name: "Programiści",
    ikona: FaCode,
  },
  {
    key: "modelers_objects",
    discordRole: "Modeler obiektów",
    name: "Modelerzy obiektów",
    ikona: FaBuilding,
  },
  {
    key: "modelers_vehicles",
    discordRole: "Modeler pojazdów",
    name: "Modelerzy pojazdów",
    ikona: FaCar,
  },
  {
    key: "modelers_skins",
    discordRole: "Modeler skinów",
    name: "Modelerzy skinów",
    ikona: FaUser,
  },
  {
    key: "mappers",
    discordRole: "Mapper",
    name: "Mapperzy",
    ikona: FaMap,
  },
  {
    key: "gameplay",
    discordRole: "Projektant rozgrywki",
    name: "Projektanci rozgrywki",
    ikona: FaGamepad,
  },
  {
    key: "handling",
    discordRole: "Handlingi pojazdów",
    name: "Handlingi pojazdów",
    ikona: FaSlidersH,
  },
  {
    key: "wiki",
    discordRole: "Wikipedia",
    name: "Wikipedia",
    ikona: FaGlobe,
  },
  {
    key: "programmers_www",
    discordRole: "Programista (WWW)",
    name: "Programiści (WWW)",
    ikona: FaLaptopCode,
  },
  {
    key: "graphics",
    discordRole: "Grafik",
    name: "Graficy",
    ikona: FaPalette,
  },
  {
    key: "management",
    discordRole: null,
    rconOnly: true,
    name: "Organizacja projektu",
    ikona: FaClipboardList,
  },
  {
    key: "uncategorized",
    name: "Inne",
    ikona: FaQuestionCircle,
  },
];

export const categoryPath = (key) => `/${key}`;

export const findCategory = (key) =>
  CATEGORIES.find((k) => k.key === key);

export const categoryForRole = (nazwaRoli) =>
  CATEGORIES.find((k) => k.discordRole && k.discordRole === nazwaRoli)?.key || null;

export const visibleCategories = (isRcon) =>
  CATEGORIES.filter((k) => !k.rconOnly || isRcon);

export const MY_TASKS_PATH = "/moje";

export const PROJECT_STATUS_PATH = "/project-status";

export const ROADMAP_PATH = "/roadmapa";

export const ACTIVITY_PATH = "/log";

export const LOGS_PATH = "/logi";

export const TASK_PATH = "/zadanie";

export const DEFAULT_CATEGORY = CATEGORIES[0].key;
